import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider } from './Context/SnackbarContext';
import { DeleteDialogProvider } from './Context/DeleteConfirmationContext';
import { pdfjs } from 'react-pdf';
import { WarningPopContextProvider } from './Context/WarningPopContext';
import { LoadingBackdropProvider } from './Context/LoadingBackdropContext';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <SnackbarProvider>
    <DeleteDialogProvider>
      <WarningPopContextProvider>
        <LoadingBackdropProvider>
          <App />
        </LoadingBackdropProvider>
      </WarningPopContextProvider>
    </DeleteDialogProvider>
  </SnackbarProvider>

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
